<template>
    <div>
        
        <div class="select mb-5" >
            <select v-model="grade_id" :disabled="loading==true" @change="getGradeCourses()">
                <option value="">Select a grade ...</option>
                <option v-for="row in grades" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
        </div>

        

        <h4 class="title is-size-4">Courses Required For Selected Grade</h4>

        <div class="notification is-warning" v-if="loading == true">
            Loading courses ...
        </div>
        <div class="notification is-danger" v-if="loading == false  && grade_courses.length == 0">
            No required courses can be found for that grade
        </div>

        <table class="table is-fullwidth is-hoverable " v-if="loading == false && this.grade_courses.length > 0">
            <thead>
                <tr>
                    <th>Course</th>
                    <th>Validity (months)</th>
                    
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.grade_courses" :key="row.id" >
                    
                    <td>{{ row.name }}</td>
                    <td>{{ row.valid_for_months }}</td>
                    
                    
                </tr>
                
                
            </tbody>
            
        </table>


       

       
    </div>
</template>

<script>

import UtilityService from '@/services/UtilityService.js';
import MemberMixin from '@/mixins/MemberMixin.js';



export default {
    
      name: 'GradeCourses',
        mixins: [MemberMixin],
        components: {
            
        },
        data: function () {
            return {
                member_search: '',
                grade_courses: [],
                   loading: false,
                   searchPerformed: false,
                   showModal: false,
                   order_by: 'name ASC',
                   accessToken: '',
                  grade_id:'',
                   grades: [],
                   
            }
        },
        methods: {
            async getGradeCourses()
            {
                this.loading = true
                if(this.grade_id != "" && this.grade_id != null)
                {
                    
                    UtilityService.getSimpleApiData(this.accessToken, "grade_courses/" + this.grade_id).then(
                        (response) => {
                            this.grade_courses = response 
                            this.loading = false
                            
                        }
                    );
                }
                else {
                    this.loading = false
                }

               
            },
            
        },
        created() {
            this.getAccessToken()
                .then(() => { 
                    this.getGrades();
                    this.getGradeCourses();
                });
        
        },
        mounted() {
            
        },
        computed: {
           
        }
       
    }
</script>